// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Bus from './utils/bus' //这是我的路径，正确引用你们的路径
import VueWechatTitle from 'vue-wechat-title'; 

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueWechatTitle);
import animated from 'animate.css'
Vue.use(animated)
Vue.prototype.$bus = Bus 

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js